import { graphql } from 'react-relay';
import { USER_RECOMMENDATION_TYPE } from 'dibs-personalized/exports/siglipRecsTestHelpers.ts';
import { MIXED_GRID_DESKTOP_INITIAL_FETCH_COUNT } from '../homepagePersonalized/buildHpPersonalizedMixedGrid.ts';
import { type homepageDefaultRootQuery$variables } from './__generated__/homepageDefaultRootQuery.graphql.ts';

const homepageDefaultRootQuery = graphql`
    query homepageDefaultRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $fetchInitialHomepage: Boolean!
        $userId: String!
        $hasUserId: Boolean!
        $userType: String!
        $abTestList: [String] = []
        $isRemoveTopHeroBannerTestVariant: Boolean!
        $isPersonalizedContentAboveFoldTestVariant: Boolean!
        $recommendationType: UserRecommendationType!
        $isTrade: Boolean!
        $priceBookName: String!
        $mixedGridFirst: Int = 8
    ) {
        viewer {
            ...HpDefaultLayout_viewer
                @arguments(
                    recommendationType: $recommendationType
                    isPersonalizedContentAboveFoldTestVariant: $isPersonalizedContentAboveFoldTestVariant
                    mixedGridFirst: $mixedGridFirst
                )
            ...isEmptyHomePage_viewer
            ...getHomePageMetaContent_viewer
        }
    }
`;

const homepageDefaultVariables: homepageDefaultRootQuery$variables = {
    fetchInitialHomepage: true,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    userType: '',
    isRemoveTopHeroBannerTestVariant: false,
    isPersonalizedContentAboveFoldTestVariant: false,
    recommendationType: USER_RECOMMENDATION_TYPE.PERSONALIZED,
    isTrade: false,
    priceBookName: 'DEFAULT',
    mixedGridFirst: MIXED_GRID_DESKTOP_INITIAL_FETCH_COUNT,
};

export { homepageDefaultRootQuery, homepageDefaultVariables };
